import $ from "jquery";
import "slick-carousel";
import AOS from "aos";
import lozad from "lozad";

$(function () {
	"use strict";

	// $( "<div class='grid-container' style='position: relative;'>Test</div>" ).insertAfter( "#ImageGallery" );

	// Slick sliders
	$(".ImageCarousel-2").on("init", function (event, slick) {
		AOS.init();
		const observer = lozad(); // lazy loads elements with default selector as ".lozad"
		observer.observe();
	});
	$(".ImageCarousel-2").slick({
		centerMode: true,
		arrows: true,
		dots: false,
		// centerPadding: '60px',
		infinite: true,
		variableWidth: true,
		slidesToShow: 3,
		responsive: [
			// {
			// 	breakpoint: 768,
			// 	settings: {
			// 		arrows: false,
			// 		dots: true,
			// 		// centerMode: true,
			// 		infinite: true,
			// 		// variableWidth: true,
			// 		// centerPadding: '40px',
			// 		slidesToShow: 3
			// 	}
			// },
			{
				breakpoint: 924,
				settings: {
					dots: true,
					arrows: false,
					// centerMode: true,
					infinite: true,
					// variableWidth: true,
					// centerPadding: '40px',
					slidesToShow: 3
				}
			}
		]
	});
	// $( ".slick-slider" ).prepend( "<div class='grid-container' style='position: relative;'>Test</div>" );

});


import "../../node_modules/slick-carousel/slick/slick.css";
import "../../node_modules/slick-carousel/slick/slick-theme.css";
